import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import reportWebVitals from "./reportWebVitals";
import HomeForm from "./home/HomeForm";
import SettingsForm from "./settings/SettingsForm";
import UserDetails from "./users/UserDetails";
import AdminForm from "./admin/AdminForm";
import AccountantForm from "./accountant/AccountantForm";
import ClientForm from "./client/ClientForm";
import AddClientForm from "./client/AddClientForm";
import AddAdminForm from "./admin/AddAdminForm";
import CategoryForm from "./category/CategoryForm";
import PatchUser from "./users/PatchUser";
import AddCategoryForm from "./category/AddCategoryForm";
import CompanyPolicyForm from "./company/CompanyForm";
import PatchCompanyPolicy from "./company/PatchCompanyPolicy";
import AddCompanyPolicy from "./company/AddCompanyPolicy";
import ExpenseReportForm from "./expense_report/ExpenseReportForm";
import ExpenseReportDetails from "./expense_report/ExpenseReportDetails";
import EditExpenseReportPage from "./expense_report/EditExpenseReportPage";
import EditExpenseReportItemPage from "./expense_report/EditExpenseReportItemPage";
import UpdateExpenseReportStatusPage from "./expense_report/UpdateExpenseReportStatusPage";
import DashboardForm from "./dashboard/DashboardForm";
import OfficeForm from "./office/OfficeForm";
import OfficeDetails from "./office/OfficeDetails";
import AddOfficeForm from "./office/AddOfficeForm";
import CorporateForm from "./corporate/CorporateForm";
import AddAccountantForm from "./accountant/AddAccountantForm";
import UpgradePage from "./upgrade/UpgradePage";
import AccountForm from "./components/Navbar/AccountForm";
import NotificationsForm from "./notification/NotificationsForm";
import { ThemeProvider } from "./utils/ThemeContext";
import ResetPasswordForm from "./connect/ResetPassword";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/forgot-password" element={<ResetPasswordForm />} />
            <Route path="/notifications" element={<NotificationsForm />} />
            <Route path="/dashboard" element={<DashboardForm />} />
            <Route path="/users" element={<HomeForm />} />
            <Route path="/admins" element={<AdminForm />} />
            <Route path="/accountants" element={<AccountantForm />} />
            <Route path="/clients" element={<ClientForm />} />
            <Route path="/add-client" element={<AddClientForm />} />
            <Route path="/add-admin" element={<AddAdminForm />} />
            <Route path="/add-accountant" element={<AddAccountantForm />} />
            <Route path="/users/:firebaseUid" element={<UserDetails />} />
            <Route path="/users/:firebaseUid/edit" element={<PatchUser />} />
            <Route path="/categories" element={<CategoryForm />} />
            <Route path="/add-category" element={<AddCategoryForm />} />

            <Route path="/company-policies" element={<CompanyPolicyForm />} />
            <Route
              path="/companies/:companyUuid/policies"
              element={<CompanyPolicyForm />}
            />
            <Route
              path="/companies/:companyUuid/policies/:policyUuid/edit"
              element={<PatchCompanyPolicy />}
            />
            <Route
              path="/companies/:companyUuid/policies/add"
              element={<AddCompanyPolicy />}
            />
            <Route path="/settings" element={<SettingsForm />} />
            <Route path="/account" element={<AccountForm />} />
            <Route path="/expense-reports" element={<ExpenseReportForm />} />
            <Route
              path="/expense-reports/:expenseReportUuid"
              element={<ExpenseReportDetails />}
            />
            <Route
              path="/expense-reports/:uuid/edit"
              element={<EditExpenseReportPage />}
            />
            <Route
              path="/expense-report-items/:uuid/edit"
              element={<EditExpenseReportItemPage />}
            />
            <Route
              path="/expense-reports/:uuid/status"
              element={<UpdateExpenseReportStatusPage />}
            />
            <Route path="/offices" element={<OfficeForm />} />
            <Route path="/offices/:companyUuid" element={<OfficeDetails />} />
            <Route path="/add-office" element={<AddOfficeForm />} />
            <Route path="/corporate" element={<CorporateForm />} />
            <Route path="/upgrade" element={<UpgradePage />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
